<template>
  <div class="service-terms-page">
    <div class="menu-list">
      <div
        class="menu-item acea-row row-between-wrapper"
        @click="$router.push({ path: '/user/service_terms/auth_service' })"
      >
        <div class="menu-left acea-row row-middle">
          <div class="menu-icon menu-icon-auth">
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                d="M24 6l14 6v10c0 9.5-6.2 16.4-14 20-7.8-3.6-14-10.5-14-20V12l14-6z"
                fill="#fff"
              />
              <path
                d="M18.5 24.2l4.2 4.2 7.8-8.2"
                fill="none"
                stroke="#e93323"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="menu-text">认证服务协议</div>
        </div>
        <span class="iconfont icon-xiangyou"></span>
      </div>

      <div
        class="menu-item acea-row row-between-wrapper"
        @click="$router.push({ path: '/user/service_terms/user_register' })"
      >
        <div class="menu-left acea-row row-middle">
          <div class="menu-icon menu-icon-register">
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <rect x="10" y="8" width="28" height="32" rx="3" fill="#fff" />
              <rect x="15" y="14" width="18" height="2.5" rx="1.2" fill="#4a90e2" />
              <rect x="15" y="21" width="18" height="2.5" rx="1.2" fill="#4a90e2" />
              <rect x="15" y="28" width="12" height="2.5" rx="1.2" fill="#4a90e2" />
              <circle cx="34" cy="34" r="7" fill="#4a90e2" />
              <path
                d="M34 30.5v7M30.5 34h7"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div class="menu-text">用户协议</div>
        </div>
        <span class="iconfont icon-xiangyou"></span>
      </div>

      <div
        class="menu-item acea-row row-between-wrapper"
        @click="$router.push({ path: '/user/service_terms/privacy' })"
      >
        <div class="menu-left acea-row row-middle">
          <div class="menu-icon menu-icon-privacy">
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <rect x="12" y="20" width="24" height="20" rx="3" fill="#fff" />
              <path
                d="M18 20v-5a6 6 0 0 1 12 0v5"
                fill="none"
                stroke="#fff"
                stroke-width="3"
                stroke-linecap="round"
              />
              <circle cx="24" cy="29" r="2.5" fill="#2bb673" />
              <path
                d="M24 31.5v4"
                stroke="#2bb673"
                stroke-width="2.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div class="menu-text">隐私协议</div>
        </div>
        <span class="iconfont icon-xiangyou"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceTerms"
};
</script>

<style scoped>
.service-terms-page {
  background-color: #f5f5f5;
  padding: 0.24rem 0.2rem;
  box-sizing: border-box;
  overflow: hidden;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.menu-item {
  background-color: #fff;
  border-radius: 0.12rem;
  padding: 0.34rem 0.3rem;
}

.menu-left {
  flex: 1;
  min-width: 0;
}

.menu-icon {
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-icon svg {
  width: 0.48rem;
  height: 0.48rem;
  display: block;
}

.menu-icon-auth {
  background: linear-gradient(135deg, #ff6b6b 0%, #e93323 100%);
}

.menu-icon-register {
  background: linear-gradient(135deg, #6eb5ff 0%, #4a90e2 100%);
}

.menu-icon-privacy {
  background: linear-gradient(135deg, #5fd49a 0%, #2bb673 100%);
}

.menu-text {
  margin-left: 0.24rem;
  font-size: 0.3rem;
  color: #282828;
}

.menu-item .icon-xiangyou {
  font-size: 0.26rem;
  color: #c8c8c8;
}
</style>
